const TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

export const uuid = () =>
  window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : TEMPLATE.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0;

        return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
      });
